import { Component, EventEmitter, Input, Output } from "@angular/core";
import { environment } from "../../../environments/environment";
import { BvDialogComponent, BvDialogTitleComponent, BvDialogBodyComponent, BvDialogFooterComponent } from "../../design-system/primitives/dialog.component";
import { BvStackComponent } from "../../design-system/primitives/stack.component";
import { BvCheckboxComponent } from "../../design-system/primitives/checkbox.component";
import { FormsModule } from "@angular/forms";
import { BvButtonComponent } from "../../design-system/primitives/button.component";
import { TranslateModule } from "@ngx-translate/core";

/**
 * Interstitial shown on next login when profile.tcAcceptedVersion is missing
 * or older than the published T&C/Privacy effective date.
 *
 * Declarative: parent mounts the component once and toggles [open]. The user
 * can accept (emits `accepted`) or log out (emits `loggedOut`); the bv-dialog
 * has closeOnBackdrop and closeOnEscape disabled so the only way out is one
 * of those two paths. ProfileService listens to both events.
 */
@Component({
    selector: "app-tc-acceptance-dialog",
    templateUrl: "./tc-acceptance-dialog.component.html",
    styleUrls: ["./tc-acceptance-dialog.component.scss"],
    imports: [BvDialogComponent, BvDialogTitleComponent, BvDialogBodyComponent, BvStackComponent, BvCheckboxComponent, FormsModule, BvDialogFooterComponent, BvButtonComponent, TranslateModule]
})
export class TcAcceptanceDialogComponent {
  @Input() open: boolean = false;
  @Output() accepted = new EventEmitter<void>();
  @Output() loggedOut = new EventEmitter<void>();

  acceptedCheckbox: boolean = false;
  termsUrl: string = `${environment.externalHomeUrl}/terms`;
  privacyUrl: string = `${environment.externalHomeUrl}/privacy`;

  onContinue() {
    if (!this.acceptedCheckbox) return;
    this.acceptedCheckbox = false; // reset for next time
    this.accepted.emit();
  }

  onLogout() {
    this.acceptedCheckbox = false;
    this.loggedOut.emit();
  }
}
